export const enum MstDeviceType {
  /** 0:HT */
  HT = 0,
  /** 1:プリンタ */
  PRINTER = 1
}
